/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'
import Button from '@material-ui/core/Button'
import { useFormikContext } from 'formik'

import { MainLayoutContent, MainLayoutSidebar } from 'src/features/layouts'
import { useProjectFormStyles } from './project-form.styles'
import { FormValuesProjectRequest } from '../projects.types'
import { ProjectView } from '../project-view'
import { useMediaQuery, useTheme } from '@material-ui/core'
import { ProjectFormOverallData } from './project-form-overall-data'
import { ProjectFormCharacteristics } from './project-form-characteristics'
import { ProjectFormOthers } from './project-form-others/project-form-others'
import { ProjectEditWarnModal } from '../project-edit-warn-modal'
import { ProfileDetails } from 'src/features/profile-details'
import { useLocale, useTranslation } from '@plandi/common'

type ProjectFormProps = {
  profileType?: string
  buttons?: React.ReactNode
  publishedAt?: {
    date: string
    timezone: string
    timezone_type: number
  }
  isPreviewMode?: boolean
  setIsPreviewMode?: (value: boolean) => void
}

export const ProjectForm: React.FC<ProjectFormProps> = (props) => {
  const classes = useProjectFormStyles()
  const theme = useTheme()
  const [isWarnModalVisible, setIsWarnModalVisible] = useState(false)
  const [isPreviewMode, setIsPreviewMode] = useState(false)
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const { data: translate } = useTranslation()
  const locale = useLocale()
  const formik = useFormikContext<FormValuesProjectRequest>()

  if (isPreviewMode) {
    const cover = formik.values.cover?.data?.toString()
    const createdAt: any = props.publishedAt ?? new Date().toISOString()
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const images = formik.values.images
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ?.map((file) => file.data?.toString())
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      .filter((val): val is string => Boolean(val))

    const parts = (formik.values.parts ?? [])
      ?.map((part) => part.name)
      .filter((partName): partName is string => Boolean(partName))

    return (
      <form onSubmit={formik.handleSubmit} className={classes.form}>
        <ProjectView
          isPreviewMode
          createdAt={createdAt}
          {...formik.values}
          cover={cover}
          images={images}
          parts={parts}
          translate={translate}
          locale={locale}
        />
        <div className={classes.groupButton}>
          <Button
            onClick={() => setIsPreviewMode(false)}
            className={classes.draft}
          >
            {translate?.['edit-btn']}
          </Button>
          {props.buttons}
        </div>
      </form>
    )
  }

  return (
    <>
      <MainLayoutSidebar withSticky size="large">
        <ProfileDetails create profileType={props.profileType} />
      </MainLayoutSidebar>
      <MainLayoutContent>
        <form onSubmit={formik.handleSubmit}>
          {isWarnModalVisible && (
            <ProjectEditWarnModal
              onLeave={() => {
                setIsWarnModalVisible(false)
                setIsPreviewMode(true)
              }}
              onCancel={() => {
                setIsWarnModalVisible(false)
              }}
              translate={translate}
            />
          )}
          <ProjectFormOverallData translate={translate} />
          <ProjectFormCharacteristics />
          <ProjectFormOthers translate={translate} />
          {isMobile ? (
            <div className={classes.groupButton}>
              {props.buttons}
              <div className={classes.groupButtonMobile}>
                <Button
                  className={classes.draft}
                  onClick={() => setIsWarnModalVisible(true)}
                >
                  {translate?.shop['add-model-page']['cancel']}
                </Button>
                <Button
                  className={classes.draft}
                  onClick={() => setIsPreviewMode(true)}
                >
                  {translate?.shop['add-model-page']['to-view']}
                </Button>
              </div>
            </div>
          ) : (
            <div className={classes.groupButton}>
              <Button
                className={classes.draft}
                onClick={() => {
                  setIsWarnModalVisible(true)
                }}
              >
                {translate?.shop['add-model-page']['cancel']}
              </Button>
              <Button
                className={classes.draft}
                onClick={() => setIsPreviewMode(true)}
              >
                {translate?.shop['add-model-page']['to-view']}
              </Button>
              {props.buttons}
            </div>
          )}
        </form>
      </MainLayoutContent>
    </>
  )
}
